import BaseVM from './base-vm';
var CourseworkViewModel = function() { this.init.apply(this, arguments); };
CourseworkViewModel.prototype = Kadenze.Util.extendClass(BaseVM, {
  isSortable: ko.observable(false),

  init: function(data, wizard) {
    var self = this;

    this.super('init', wizard, data);
    this.mapping = {};

    ko.mapping.fromJS(data, this.mapping, this);

    this.courseworkCount = ko.computed(function() {
      return self.coursework_ids().length;
    });
  },

  initUI: function() {
    this.initialized = true;

    if(this.adaptive()) {
      this.isSortable(true);
      this.initSorting();
    }
  },

  initSorting: function() {
    var self = this,
      $el = $('.js-coursework-sortable');

    $el.sortable({
      itemSelector: '.display-table__data',
      handle: '.display-table__sort-handle',
      update: function(event, ui) {
        self.onSortUpdate($el, event, ui);
      }
    });
  },

  onSortUpdate: function($el, event, ui) {
    var request,
      self = this,
      requestUrl = Kadenze.Routes.sort_coursework_course_session_path(this.data.course_id, this.data.id);
    ids = $el.find('.display-table__data').map(function() { return $(this).data('courseworkId'); });

    request = new Kadenze.AjaxRequest({
      url: requestUrl,
      type: 'PATCH',
      dataAsJSON: false,
      data: { coursework_ids: ids.get() },
      loadingIndicator: {
        container: self.getContainer()
      }
    });

    request.done(function() {
      new Kadenze.Notice.success({ message: self.successMessage });
    });
  },

  reBind: function(session) {
    if(session.existing_coursework){
      this.existing_coursework = ko.mapping.fromJS(session.existing_coursework);
    } else {
      this.existing_coursework([]);
    }
    if(session.course_coursework){
      this.course_coursework = ko.mapping.fromJS(session.course_coursework);
    } else {
      this.course_coursework([]);
    }

    if(this.adaptive()) {
      this.isSortable(true);
      this.initSorting();
    }
  },

  // Minimum requirements to consider this page 'done'
  hasData: function() {
    return this.coursework_ids().length > 0 ? true : false;
  },

  getSummary: function() {
    return {
      id: 4, // allow's KO to update items easily
      heading: Kadenze.I18n.t('session.publish_summary.session_coursework'),
      overviewItems: [
        { title: Kadenze.I18n.t('session.publish_summary.coursework_attached'), description: this.courseworkCount }
      ]
    };
  },
});
export default CourseworkViewModel;


